/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React, {Component} from 'react';
import {Input} from '@scuf/common';

class SearchInput extends Component {

    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value || '',
            requestedTimeOut: this.props.setUpTimeout || 300,
        }

        this.onSearchChange = this.onSearchChange.bind(this);
        this.timeout = 0;
    }

    componentDidUpdate(prevProps){
        if(prevProps.value !== this.props.value) {
            this.setState({value: this.props.value})
        }
    }

    onSearchChange(value) {
        const me = this
        me.setState({value: value})

        clearTimeout(this.timeout)
        this.timeout = setTimeout(function() {
            me.props.onChange(value)
        }, me.state.requestedTimeOut)
    }


    render() {
        return (
            <Input {...this.props} value={this.state.value} onChange={this.onSearchChange} search={true}/>
        );
    }
}

export default SearchInput;
